import React from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';

class ApexChartBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [{
        name: 'Subscription Count',
        data: []
      }],
      options: {
        chart: {
          height: 350,
          type: 'bar',
        },
        colors: ['#FB7B54'],
        plotOptions: {
          bar: {
            borderRadius: 5,
            horizontal: true,
            borderRadiusApplication: 'end',
            
          },},
        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return val; // Display the count directly
          },
          style: {
            fontSize: '12px',
            padding:'10px',
            borderRadius:'5px'
          },
        },
        xaxis: {
          categories: [],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: true,
            formatter: function (val) {
              return val; // Display the count directly
            }
          }
        },
        title: {
          floating: true,
          offsetY: 10,
          align: 'center',
          style: {
            color: '#000'
          }
        }
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedMonth !== this.props.selectedMonth) {
      this.fetchData();
    }
  }

  fetchData = async () => {
    try {
      let response;
      if (this.props.selectedMonth) {
        response = await axios.post('https://zingapi.beeinnovations.com/boxoffice_app/plan_subscription.php', {
          month: this.props.selectedMonth
        });
      } else {
        response = await axios.get('https://zingapi.beeinnovations.com/boxoffice_app/plan_subscription.php');
      }

      const data = response.data.plan_subscription;
      const categories = data.map(item => item.plan);
      const seriesData = data.map(item => item.count);

      this.setState({
        series: [{
          name: 'Subscription Count',
          data: seriesData
        }],
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: categories
          }
        }
      });
    } catch (error) {
      console.error('Error fetching data', error);
    }
  };

  render() {
    return (
      <div id="chart">
        <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={350} />
      </div>
    );
  }
}

export default ApexChartBar;
